import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { atLeastIn } from "@client/lib/misc";
import { type HttpApiResponse } from "@client/types/Api";
import { ProductList } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: ProductList.Api.InitRequest
  ): Promise<HttpApiResponse<ProductList.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/productList`, args),
  getPage: (
    apiInfo: ModuleApiInfo,
    args: ProductList.Api.GetProductPageRequest
  ): Promise<HttpApiResponse<ProductList.Api.GetProductsResponse>> =>
    atLeastIn(api.get(apiInfo, `/api/site/v1/modules/productList/page`, args), 300)
};
